import { api } from "./api";

const SID_KEY = "stuff_sid";
export function getSid() {
  let sid = localStorage.getItem(SID_KEY);
  if (!sid) {
    sid = (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`).slice(0, 40);
    localStorage.setItem(SID_KEY, sid);
  }
  return sid;
}

const device = () => (window.innerWidth < 768 ? "mobile" : window.innerWidth < 1024 ? "tablet" : "desktop");

export function track(type, extra = {}) {
  try {
    const params = new URLSearchParams(window.location.search);
    api.post("/track", {
      type,
      path: window.location.pathname,
      sid: getSid(),
      city: localStorage.getItem("stuff_city") || "",
      ref: type === "pageview" ? document.referrer || "" : "",
      utm_source: params.get("utm_source") || "",
      device: device(),
      ...extra,
    }).catch(() => {});
  } catch (e) { console.debug("track", e); }
}
